export const EXPENSE_CATEGORIES = [
  { value: "food", label: "Alimentación", emoji: "🍔" },
  { value: "transport", label: "Transporte", emoji: "🚗" },
  { value: "lodging", label: "Alojamiento", emoji: "🏨" },
  { value: "shopping", label: "Compras", emoji: "🛒" },
  { value: "leisure", label: "Ocio", emoji: "🎉" },
  { value: "home", label: "Hogar", emoji: "🏠" },
  { value: "work", label: "Trabajo", emoji: "💼" },
  { value: "other", label: "Otros", emoji: "📦" },
];

export const CAT_MAP = Object.fromEntries(EXPENSE_CATEGORIES.map((c) => [c.value, c]));

export const CURRENCIES = ["EUR", "USD", "GBP", "MXN", "ARS", "COP"];

export const SPLIT_LABELS = {
  equal: "Igualitario",
  custom: "Importes personalizados",
  percentage: "Por porcentaje",
  none: "Solo paga una persona",
};

export const EXPENSE_STATUS = [
  { value: "pending", label: "Pendiente", color: "#F9AB00" },
  { value: "settled", label: "Liquidado", color: "#1E8E3E" },
  { value: "cancelled", label: "Anulado", color: "#9AA0A6" },
];

export const STATUS_MAP_EXP = Object.fromEntries(EXPENSE_STATUS.map((s) => [s.value, s]));

export const fmtMoney = (amount, currency = "EUR") =>
  new Intl.NumberFormat("es-ES", { style: "currency", currency }).format(amount);

export const budgetColor = (pct) => (pct < 75 ? "#1E8E3E" : pct <= 90 ? "#F9AB00" : "#D93025");
